import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const GET_PROJECT = gql`
  query Project($projectId: ID!) {
    project(projectId: $projectId) {
      ...BaseProject
    }
  }
  ${fragments.baseProject}
`

export const GET_PROJECTS = gql`
  query Projects($userId: String) {
    projects(userId: $userId) {
      ...ProjectLight
    }
    projectIndex @client
  }
  ${fragments.baseProjectLight}
`

export const GET_GROUP_PROJECTS = gql`
  query GroupProjects($groupId: ID!) {
    groupProjects(groupId: $groupId) {
      ...ProjectLight
    }
  }
  ${fragments.baseProjectLight}
`

export const GET_PROJECTS_EXITS = gql`
  query Projects($userId: String) {
    projects(userId: $userId) {
      ...ProjectLightWithExits
    }
  }
  ${fragments.baseProjectLightWithExits}
`

export const ADD_PROJECT = gql`
  mutation AddProject($userId: String!, $input: BaseProjectInput!) {
    addProject(userId: $userId, projectInput: $input) {
      ...BaseProject
    }
  }
  ${fragments.baseProject}
`

export const SAVE_PROJECT = gql`
  mutation SaveProject($projectId: ID!, $input: BaseProjectInput!) {
    saveProject(projectId: $projectId, projectInput: $input) {
      ...BaseProject
    }
  }
  ${fragments.baseProject}
`

// Update the company of the project additionally (added on addProject)
export const ADD_PROJECT_COMPANY = gql`
  mutation AddProjectCompany(
    $userId: String!
    $input: BaseProjectInput!
    $companyInput: CompanyInput!
  ) {
    addProjectCompany(userId: $userId, projectInput: $input, companyInput: $companyInput) {
      ...BaseProject
    }
  }
  ${fragments.baseProject}
`

export const SAVE_PROJECT_COMPANY = gql`
  mutation SaveProjectCompany(
    $projectId: ID!
    $input: BaseProjectInput!
    $companyInput: CompanyInput!
  ) {
    saveProjectCompany(projectId: $projectId, projectInput: $input, companyInput: $companyInput) {
      ...BaseProject
    }
  }
  ${fragments.baseProject}
`

// Is using cascade mode to delete all project entities
export const DELETE_PROJECT = gql`
  mutation DeleteProject($projectId: ID!) {
    deleteProject(projectId: $projectId)
  }
`

const mutations = {
  addRemote: ADD_PROJECT,
  saveRemote: SAVE_PROJECT,
  deleteRemote: DELETE_PROJECT,
  saveOp: 'saveProject',
  addOp: 'addProject',
  deleteOp: 'deleteProject',
}

export const projectsQueries = { ...mutations, getRemote: GET_PROJECTS }
